var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDimond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52002 3.47167L9.45791 3.64442L6.55418 6.87926L5.52002 3.47167ZM9.48846 16.3378L6.83478 7.79431L12.0165 8.02162L9.48846 16.3378ZM12.442 7.14661L10.6153 3.69519L14.5638 3.8684L12.442 7.14661ZM12.891 7.5571L15.0641 4.19969L17.2953 8.75442L12.891 7.5571ZM12.6183 8.10475L17.2705 9.36945L10.1176 16.3311L12.6183 8.10475ZM10.0411 3.89292L11.9058 7.41619L7.06894 7.20401L10.0411 3.89292ZM6.02901 7.21487L2.05625 7.62521L4.99242 3.79926L6.02901 7.21487ZM1.99766 8.23446L6.20813 7.79956L8.77902 16.0764L1.99766 8.23446Z",
    fill: "#4FADE4",
    stroke: "#0B0A0B",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimond);
export default __webpack_public_path__ + "static/media/dimond.d205942db88b9617ff17c163e4da130a.svg";
export { ForwardRef as ReactComponent };